export default __webpack_public_path__ + "static/media/card5.d410bedc.png";